import { useT } from "@/lib/i18n";

export const FounderPhoto = ({ className = "", testid = "founder-photo" }) => {
  const t = useT();
  return (
    <img
      data-testid={testid}
      src="/img/ayse.webp"
      alt={t.common.photoLabel}
      loading="lazy"
      className={`arch bg-ivory-2 object-cover object-[50%_25%] ${className}`}
    />
  );
};
